import { render } from "./ViewerItem.vue?vue&type=template&id=70042fc8&ts=true"
import script from "./ViewerItem.vue?vue&type=script&lang=ts"
export * from "./ViewerItem.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__